export default __webpack_public_path__ + "static/media/sensus-communis-logo-short.8e492ce3.svg";